import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gamepad2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './Button';

export function GameHostingPreview() {
  const { t } = useTranslation();

  return (
    <div className="py-12 md:py-20 bg-gradient-to-br from-indigo-900 to-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <Gamepad2 className="w-8 h-8" />
              <h2 className="text-2xl md:text-3xl font-bold">{t('gameHosting.title')}</h2>
            </div>
            
            <p className="text-lg md:text-xl text-blue-100 mb-8">
              {t('gameHosting.subtitle')}
            </p>

            <div className="grid grid-cols-2 gap-8 mb-8">
              <div>
                <h3 className="text-xl font-bold mb-2">
                  {t('gameHosting.categories.standard.title')}
                </h3>
                <p className="text-blue-100">
                  {t('gameHosting.categories.standard.description')}
                </p>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">
                  {t('gameHosting.categories.performance.title')}
                </h3>
                <p className="text-blue-100">
                  {t('gameHosting.categories.performance.description')}
                </p>
              </div>
            </div>

            <Link to="/game-hosting">
              <Button variant="secondary">{t('common.viewMore')}</Button>
            </Link>
          </div>

          <div className="relative hidden md:block">
            <img
              src="https://images.unsplash.com/photo-1603481588273-2f908a9a7a1b?auto=format&fit=crop&q=80&w=2070"
              alt="Gaming Server"
              className="rounded-lg shadow-2xl object-cover h-[500px] w-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/50 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
